<template>
  <div class="rt-step">
    <van-steps :active="active">
        <van-step>选择查询类型</van-step>
        <van-step>查询</van-step>
        <van-step>验证信息并核销</van-step>
        <van-step>完成</van-step>
    </van-steps>
  </div>
</template>

<script>
export default {
  props: {
    active: {
      type: Number
    },
  },
  data() {
    return {
    };
  },
 
  
};
</script>

<style lang="scss" scoped>
</style>
